<template>
  <section class="w-100 container position-relative">
    <span class="anchor"></span>
    <h2 id="compare-plans" class="title-table">
      {{ $t(`plans.${getExperience}.compareTableHead.title`) }}
    </h2>
    <b-table
      id="compare-plans-table"
      responsive
      :items="items"
      :fields="fields"
      :tbody-tr-class="trBackground"
      :class="{ visible: hover }"
    >
      <template #thead-top>
        <b-tr class="tr-border">
          <b-th class="th-font description-table">
            {{ $t(`plans.${getExperience}.compareTableHead.subtitle`) }}
          </b-th>
          <b-th class="th-font">
            {{ $t(`plans.${getExperience}.compareTableHead.firstColumn`) }}
          </b-th>
          <b-th class="th-font">
            {{ $t(`plans.${getExperience}.compareTableHead.secondColumn`) }}
          </b-th>
          <b-th class="th-font">
            {{ $t(`plans.${getExperience}.compareTableHead.thirdColumn`) }}
          </b-th>
        </b-tr>
      </template>
      <template #cell(products)="data">
        <span class="font-weight-bold">{{ $t(data.value.text) }}</span>
        <Tooltip v-if="data.value.tooltipText">
          <template #element>
            <div @mouseover="() => setHover(true)" @mouseleave="() => setHover(false)">
              <b-button id="btn-tooltip" :disabled="true" class="btn-tooltip"> i </b-button>
            </div>
          </template>
          <template #title>
            <p class="tooltip-description">
              {{ $t(data.value.tooltipText) }}
            </p>
          </template>
        </Tooltip>
      </template>
      <template #cell(pro)="data">
        <span v-if="!data.value.check && data.value.content">
          {{ data.value.content }}
        </span>
        <CrossCheckIcon v-else :is-check="data.value.check" />
      </template>
      <template #cell(merch)="data">
        <span v-if="!data.value.check && data.value.content">
          {{ data.value.content }}
        </span>
        <CrossCheckIcon v-else :is-check="data.value.check" />
      </template>
      <template #cell(business)="data">
        <span v-if="!data.value.check && data.value.content">
          {{ data.value.content }}
        </span>
        <CrossCheckIcon v-else :is-check="data.value.check" />
      </template>
    </b-table>
  </section>
</template>
<script>
import { mapGetters } from 'vuex';
import CrossCheckIcon from './CrossCheckIcon';
import Tooltip from '@/components/Common/Tooltip';
export default {
  name: 'PlansCompare',
  components: {
    CrossCheckIcon,
    Tooltip
  },
  data() {
    return {
      hover: false
    };
  },
  computed: {
    ...mapGetters('experience', ['getExperience']),
    fields() {
      return this.$g('PLANS_COMPARE_FIELDS');
    },
    items() {
      const plansByExperience = this.getExperience
        ? this.$g('PLANS_COMPARE_ITEMS')[this.getExperience]
        : [];
      return plansByExperience.map((item) => {
        let { products, pro, merch, business } = item;
        return {
          ...item,
          products,
          pro: { ...pro, content: !pro.check ? this.$t(pro.content) : '' },
          merch: { ...merch, content: !merch.check ? this.$t(merch.content) : '' },
          business: { ...business, content: !business.check ? this.$t(business.content) : '' }
        };
      });
    }
  },
  methods: {
    trBackground(item, type) {
      var classes = 'tr-font';
      if (item && type == 'row') {
        classes += item.index % 2 === 0 ? ' tr-background' : '';
      }
      return classes;
    },
    setHover(val) {
      this.hover = val;
    }
  }
};
</script>
<style lang="scss">
#compare-plans-table {
  tbody:before {
    content: '@';
    display: block;
    line-height: 25px;
    text-indent: -99999px;
  }
  thead tr:nth-child(2) {
    display: none;
  }
  td:nth-child(1) {
    display: flex;
    gap: 10px;
  }
  .description-table {
    color: $strongGray;
    font-size: 14px;
    font-weight: 400;
  }
  .tr-border {
    border-bottom: 1px $strongGray solid;
  }
  .tr-border th,
  .tr-font td {
    border: none !important;
  }
  .tr-font,
  .th-font {
    color: $strongGray;
  }
  .tr-background td {
    background-color: #f9f9f9;
  }
  .tr-background td:first-child {
    border-radius: 8px 0 0 8px;
  }
  .tr-background td:last-child {
    border-radius: 0 8px 8px 0;
  }
}
</style>
<style lang="scss" scoped>
.table-responsive {
  overflow: visible !important;
  @include md {
    overflow-x: auto !important;
  }
  &.visible {
    overflow: visible !important;
  }
}
.tooltip-parent {
  height: max-content;
}
.tooltip-description {
  letter-spacing: 0.2px;
  font-weight: 400;
}
.btn-tooltip {
  color: #fff;
  background: rgba(0, 0, 0, 0.2);
  border-radius: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  width: 24px;
  height: 24px;
  border: none;
  box-sizing: border-box;
  transform: scale(0.8);
}
.title-table {
  color: $strongGray;
  font-size: 20px;
  font-weight: 500;
}
.anchor {
  position: absolute;
  top: -100px;
}
</style>
